import { ReactNode, useState } from 'react';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { UnitOverviewCard } from '@/components/unit/UnitOverviewCard';
import Unit from '@/models/Unit';

type UnitSectionClassNames = {
  card?: string;
};

type UnitSectionProps = {
  unit: Unit;
  defaultOpen: boolean;
  shortcuts?: ReactNode;
  classNames?: UnitSectionClassNames;
  children: ReactNode;
};

export default function UnitSection({
  unit,
  defaultOpen,
  shortcuts,
  classNames,
  children,
}: UnitSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <li>
      <UnitOverviewCard
        open={open}
        onToggle={setOpen}
        className={classNames?.card}
      >
        <UnitOverviewCard.Header>
          <UnitOverviewCard.Name>{unit.name}</UnitOverviewCard.Name>
        </UnitOverviewCard.Header>
        <UnitOverviewCard.Content>
          <ConditionalRenderer condition={open}>
            <UnitOverviewCard.Summary>
              <UnitOverviewCard.Banner src={unit.bannerImg?.url} />
              {shortcuts}
            </UnitOverviewCard.Summary>
            {children}
          </ConditionalRenderer>
        </UnitOverviewCard.Content>
      </UnitOverviewCard>
    </li>
  );
}
